<template>
<div role="tabcard"
     class="tab-pane"
     id="new-work-order">
    <div class="card card-default">
        <div class="card-header">
            <div class="d-inline-block card-header-content">
                <div class="title">New work order</div>
            </div>
            <div class="d-inline-block float-right">
            </div>
        </div>
        <div class="card-body">
            <work-order-form :project="project" :workorders="workorders" v-bind:is-editing="false"></work-order-form>
        </div>
    </div>
</div>
</template>
<script>
export default
{
    props: ['role', 'project', 'workorders'],
    created: function()
    {
    },

    mounted: function() {

    },

    data: function()
    {
        return {
        };
    },

    watch:
    {

    },

    computed:
    {

    },

    methods:
    {
        
    }
}

</script>

